import { render, staticRenderFns } from "./m-two-factory-email.vue?vue&type=template&id=395a8285&"
import script from "./m-two-factory-email.vue?vue&type=script&lang=js&"
export * from "./m-two-factory-email.vue?vue&type=script&lang=js&"
import style0 from "./m-two-factory-email.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports